
export const notificationFields = [
    { label: "Notification Name *", type: "text", name: "name", placeHolder: "Notification Name", class: "", value: "", input: "text", validation: "required" },
    { label: "Audio *", type: "file", name: "audio", placeHolder: "Notification Audio", class: "custom-file-input", value: "", input: "file", validation: "" }];